import { render, staticRenderFns } from "./MeilleursMangeurs.vue?vue&type=template&id=0f40e9ab&scoped=true"
import script from "./MeilleursMangeurs.vue?vue&type=script&lang=js"
export * from "./MeilleursMangeurs.vue?vue&type=script&lang=js"
import style0 from "./MeilleursMangeurs.vue?vue&type=style&index=0&id=0f40e9ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f40e9ab",
  null
  
)

export default component.exports